
import { db } from '@/lib/firebase';
import { collection, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';

const sampleETFs = [
    {
        name: '비트코인 레버리지 ETF',
        ticker: 'BTC-L2',
        description: '비트코인의 일일 변동률을 2배로 추종하는 고수익 고위험 레버리지 ETF 상품입니다.',
        basePrice: 50000000,
        currentPrice: 52400000,
        roi: 4.8,
        aum: 125000000000,
        category: 'Leverage',
        holdings: [
            { asset: 'BTC Fut', weight: 100 }
        ],
        status: 'Active',
        vitals: [48000000, 49500000, 51000000, 50500000, 52400000]
    },
    {
        name: '메이저 알트코인 TOP 5 ETF',
        ticker: 'ALT-TOP5',
        description: '시가총액 상위 5개 알트코인(ETH, SOL, XRP, ADA, DOT)에 분산 투자하는 지수 추종형 상품입니다.',
        basePrice: 1000000,
        currentPrice: 1120000,
        roi: 12.0,
        aum: 84200000000,
        category: 'Index',
        holdings: [
            { asset: 'ETH', weight: 40 },
            { asset: 'SOL', weight: 20 },
            { asset: 'XRP', weight: 15 },
            { asset: 'ADA', weight: 15 },
            { asset: 'DOT', weight: 10 }
        ],
        status: 'Active',
        vitals: [950000, 980000, 1050000, 1100000, 1120000]
    },
    {
        name: '메타버스/NFT 테마 ETF',
        ticker: 'MV-NFT',
        description: '샌드박스, 디센트럴랜드 등 유망 메타버스 및 NFT 프로젝트 자산에 집중 투자하는 테마 상품입니다.',
        basePrice: 500000,
        currentPrice: 485000,
        roi: -3.0,
        aum: 32000000000,
        category: 'Theme',
        holdings: [
            { asset: 'SAND', weight: 30 },
            { asset: 'MANA', weight: 30 },
            { asset: 'AXS', weight: 20 },
            { asset: 'APE', weight: 20 }
        ],
        status: 'Active',
        vitals: [520000, 510000, 500000, 490000, 485000]
    }
];

export async function seedETFs() {
    const colRef = collection(db, 'etf_products');
    const snapshot = await getDocs(colRef);

    if (snapshot.empty) {
        console.log('Seeding ETF products...');
        for (const etf of sampleETFs) {
            await addDoc(colRef, {
                ...etf,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            });
        }
        return true;
    }
    return false;
}
